import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { MainLayoutComponent } from "./core/layout/main-layout/main-layout.component";
import { AutoConfirmGuard } from "./core/pages/auto-confirm/auto-confirm.guard";
import { adminSettingsGuard } from "./core/pages/admin-settings/admin-settings.guard";
import { PageNotFoundComponent } from "./core/layout/page-not-found/page-not-found.component";
import { featureRoutes } from "./configuration/feature-routes";

export const routes: Routes = [
  { path: '', redirectTo: '/pages', pathMatch: 'full' },
  {
    path: 'pages',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: 'pricing-rules',
        canActivate: [AutoConfirmGuard],
        loadComponent: () => import('./core/pages/auto-confirm/auto-confirm/auto-confirm.component').then(
          m => m.AutoConfirmComponent ),
      },
      {
        path: 'admin-settings',
        canActivate: [adminSettingsGuard],
        loadComponent: () => import('./core/pages/admin-settings/admin-settings-container/admin-settings-container.component').then(
          m => m.AdminSettingsContainerComponent )
      },
      {
        path: 'page-not-found',
        component: PageNotFoundComponent
      },
      ...featureRoutes
    ]
  },
  { path: '**', redirectTo: '/pages/page-not-found' }
];
